import axios from "axios";
import { createHeaders } from "./Constant";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-vkyc.finhub.habilelabs.io": "https://endpoint-gateway.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // prod
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // test 
  "customer-vkyc-stage.finhub.habilelabs.io": "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc",  // stage
};

const baseURL = isLocal
  ? "http://localhost:8000/api/v1/vkyc"
  : baseMap[hostname] || "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc";

console.log('SessionsService - Hostname:', hostname);
console.log('SessionsService - Is Local:', isLocal);
console.log('SessionsService - Base URL:', baseURL);

export const panService = {
  async extractPan(panFileBlob, sessionId, requestId, customerSession) {
    const form = new FormData();
    form.append("session_id", sessionId);
    form.append("request_id", requestId);
    form.append("pan_image", panFileBlob, "pan.jpg");
    if (customerSession) form.append("session", customerSession);

    const response = await axios.post(
      `${baseURL}/pan-ocr/`,
      form,
      {
        headers: {
          ...createHeaders(),
          'Content-Type': 'multipart/form-data',
          'session': customerSession
        },
      }
    );
        console.log('response :', response);

    return response.data;
  },
}; 